<template>
  <div>
    <action-bar></action-bar>
    <main class="content">
      <div v-if="dossier">
        <h1>
          Dossier bearbeiten
          <br />
          <small class="text-muted">{{dossier.name.text}}</small>
        </h1>
        <ul class="nav nav-tabs">
          <li class="nav-item">
            <router-link
              class="nav-link"
              :to="{name: 'dossier-edit', params: {dossierId: $route.params.dossierId}}"
              exact
            >Generelle Texte</router-link>
          </li>
          <li class="nav-item">
            <router-link
              class="nav-link"
              :to="{name: 'dossier-chapter-list', params: {dossierId: $route.params.dossierId}}"
              exact
            >Synthese Kapitel</router-link>
          </li>
        </ul>
        <div class="tab-content">
          <router-view
            class="tab-pane fade show active"
            entity="dossier"
            :data="dossier"
          />
        </div>
      </div>
      <loading v-else></loading>
    </main>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  asyncComputed: {
    async dossier() {
      if (!this.$route.params.dossierId) return {};

      const {
        data: { result: dossier }
      } = await axios.get(
        "/api/" +
          store.state.language +
          "/dossier/" +
          this.$route.params.dossierId
      );

      const {
        data: { result: synthesis }
      } = await axios.get(
        "/api/" + store.state.language + "/synthesis/" + dossier.synthesisId
      );

      dossier.synthesis = synthesis;

      if (dossier.synthesis.availableFrom)
        dossier.synthesis.availableFrom = moment(
          dossier.synthesis.availableFrom.date
        );

      if (dossier.synthesis.disclaimerDate)
        dossier.synthesis.disclaimerDate = moment(
          dossier.synthesis.disclaimerDate.date
        );

      return dossier;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/admin/dossier/Edit.vue